/** Scenario API client (web) — /api/v1/scenarios. The time-block editor saves
 * the whole structure atomically via PUT /{id}/content. */
import { apiClient } from '../../../services/apiClient';
import { qs } from '../../media-library/api/mediaApi';
import type {
  CreateScenarioRequest,
  PaginatedResult,
  SaveScenarioContentRequest,
  Scenario,
  ScenarioDetail,
  ScenarioLocation,
  UpdateScenarioRequest,
  UpdateSchedulingRequest,
} from '../types';

export const listScenarios = (params: { search?: string; page?: number; pageSize?: number } = {}) =>
  apiClient.get<PaginatedResult<Scenario>>(`/api/v1/scenarios${qs(params)}`);

export const getScenario = (id: string) =>
  apiClient.get<ScenarioDetail>(`/api/v1/scenarios/${id}`);

export const createScenario = (data: CreateScenarioRequest) =>
  apiClient.post<Scenario>('/api/v1/scenarios', data);

export const updateScenario = (id: string, data: UpdateScenarioRequest) =>
  apiClient.put<Scenario>(`/api/v1/scenarios/${id}`, data);

export const deleteScenario = (id: string) =>
  apiClient.delete<void>(`/api/v1/scenarios/${id}`);

export const setScenarioActive = (id: string, isActive: boolean) =>
  apiClient.put<Scenario>(`/api/v1/scenarios/${id}/active`, { isActive });

export const setScenarioLocations = (id: string, locationIds: string[]) =>
  apiClient.put<ScenarioLocation[]>(`/api/v1/scenarios/${id}/locations`, { locationIds });

export const updateScenarioScheduling = (id: string, data: UpdateSchedulingRequest) =>
  apiClient.put<Scenario>(`/api/v1/scenarios/${id}/scheduling`, data);

export const saveScenarioContent = (id: string, data: SaveScenarioContentRequest) =>
  apiClient.put<ScenarioDetail>(`/api/v1/scenarios/${id}/content`, data);
